const leadershipTeam = [
  {
    name: 'Adam Schwab',
    title: 'Co-Founder and CEO',
    image: 'cq2a11oslgzlvyvd9jeh',
    url: 'https://www.linkedin.com/in/adam-schwab-64b439a/',
  },
  {
    name: 'Andrew Ward',
    title: 'General Counsel and Company Secretary',
    image: '48k6xbs6kemb22u73',
    url: 'https://www.linkedin.com/in/andrew-ward-5033ba30/',
  },
  {
    name: 'Julia Davis',
    title: 'Chief of Staff',
    image: '8cdvsyg8msmran0i3lnt',
    url: 'https://www.linkedin.com/in/juliaedavis/',
  },
  {
    name: 'Natalie Morwood',
    title: 'Chief Financial Officer',
    image: 'zb4yrlo33qg3mzntxfhs',
    url: 'https://www.linkedin.com/in/natalie-morwood-93138a37/',
  },
  {
    name: 'Shay Hamama',
    title: 'Chief Product & Technology Officer',
    image: 'bv7ddryg6c8gqr8icva',
    url: 'https://www.linkedin.com/in/shayhamama/',
  },
  {
    name: 'Kieran Perkins',
    title: 'Chief Customer Experience & Sales Officer',
    image: '5xc5orvliaez3toizb1a',
    url: 'https://www.linkedin.com/in/kieran-perkins-074b2947/',
  },
  {
    name: 'Daniel Monk',
    title: 'Chief Sales & Distribution Officer',
    image: 'Daniel-Monk.png',
    url: 'https://www.linkedin.com/in/daniel-monk-1679952b/',
  },
  {
    name: 'Ben Connell',
    title: 'Chief Marketing Officer',
    image: '56nkusxivv0mnt60cxk',
    url: 'https://www.linkedin.com/in/ben-connell-8850133a/',
  },
]

export default leadershipTeam
